"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchResultsQuery = exports.QUERY_NAME = void 0;
var _presentationUtils = require("@ori/presentation-utils");
/* istanbul ignore file -- tested in PLP */

const QUERY_NAME = exports.QUERY_NAME = 'query';
const getSearchResultsQuery = () => {
  const query = (0, _presentationUtils.getTypedQueryParam)({
    name: QUERY_NAME
  });
  return (query ?? '').trim();
};
exports.getSearchResultsQuery = getSearchResultsQuery;
//# sourceMappingURL=utils.js.map